export const ratingErrorInformation: { [id: string]: string } = {
  userRatingAlreadyExistForArticle:
    "You seem to have already rated the article previously",
};
